import axios from 'axios';
const apiBaseUrl = process.env.VUE_APP_BASE_API;
axios.defaults.baseURL =  apiBaseUrl;
export default axios;